import React from 'react';

import Icon from '../Icon/Icon';

const AutoCleanBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path
                    d='M29.29 15.459C26.96 12.11 24.603 9.74 24 9.74c-1.28 0-10.5 11.429-10.5 18.759 0 5.799 4.701 9.75 10.5 9.75s10.5-3.951 10.5-9.75c0-1.674-.399-3.462-1.042-5.246'
                    stroke='#34303D'
                    strokeWidth='2'
                />
                <path
                    d='M24 34.497c3.728 0 6.75-2.54 6.75-6.267C30.75 23.055 24.822 15 24 15c-.822 0-6.75 8.517-6.75 13.23 0 3.728 3.022 6.267 6.75 6.267z'
                    fill='#00D1D2'
                    fillRule='nonzero'
                />
                <path
                    d='M37.5 7.235c.166.82.572 1.554 1.142 2.124.57.57 1.306.977 2.127 1.142a4.172 4.172 0 0 0-2.127 1.141 4.172 4.172 0 0 0-1.142 2.124 4.173 4.173 0 0 0-1.142-2.124 4.172 4.172 0 0 0-2.128-1.141 4.172 4.172 0 0 0 2.128-1.142c.57-.57.976-1.304 1.142-2.124z'
                    stroke='#34303D'
                    strokeWidth='2'
                />
                <path
                    d='M30.748 13a.745.745 0 0 1 .742.652 6.81 6.81 0 0 0 1.94 3.916 6.81 6.81 0 0 0 3.917 1.939.748.748 0 0 1 .464 1.236.748.748 0 0 1-.463.25 6.81 6.81 0 0 0-3.917 1.938 6.81 6.81 0 0 0-1.941 3.917.75.75 0 0 1-.742.652.745.745 0 0 1-.741-.652 6.812 6.812 0 0 0-1.941-3.917 6.809 6.809 0 0 0-3.916-1.938.748.748 0 0 1-.65-.743.748.748 0 0 1 .648-.743 6.81 6.81 0 0 0 3.918-1.939 6.813 6.813 0 0 0 1.94-3.917.75.75 0 0 1 .742-.651z'
                    stroke='#34303D'
                    strokeWidth='2'
                    fill='#FFFDFB'
                />
            </g>
        </Icon>
    );
};

export default AutoCleanBlueIcon;
